import { Link } from "react-router-dom";

export default function LegalFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="px-6 py-6 border-t border-border/60 text-xs text-muted-foreground flex flex-col sm:flex-row sm:flex-wrap items-center justify-center gap-2 sm:gap-4"
      data-testid="legal-footer"
    >
      <p
        className="w-full text-center text-sm font-medium text-foreground/90 sm:mb-1"
        data-testid="legal-footer-ownership"
      >
        FINALLOOK is owned and operated by HEAR ME NOW MUSIC GROUP LLC.
      </p>
      <span className="text-center" data-testid="legal-footer-copyright">&copy; {year} HEAR ME NOW MUSIC GROUP LLC. All rights reserved.</span>
      <span className="hidden sm:inline text-border">·</span>
      <Link
        to="/privacy"
        className="hover:text-foreground transition-colors"
        data-testid="footer-privacy-link"
      >
        Privacy Policy
      </Link>
      <span className="hidden sm:inline text-border">·</span>
      <Link
        to="/terms"
        className="hover:text-foreground transition-colors"
        data-testid="footer-terms-link"
      >
        Terms of Service
      </Link>
      <span className="hidden sm:inline text-border">·</span>
      <Link
        to="/contact"
        className="hover:text-foreground transition-colors"
        data-testid="footer-contact-link"
      >
        Contact Us
      </Link>
    </footer>
  );
}
